import type { DialogProps } from '@mui/material'
import { UIDialog } from 'src/components/ui/Modal'
import { cn } from 'src/utils/cx'
import { match } from 'ts-pattern'

type DialogOption = Omit<DialogProps, 'open'> & {
  responsive?: boolean
  afterClose?: () => any
  onClose?: () => any
  /**
   * For responsive mode's `Dialog` component
   *
   * @deprecated Use top-level props instead
   */
  dialogProps?: Partial<DialogProps>
  disableBackdropClick?: boolean
}

/**
 * @deprecated Use `UIDialog` instead
 */
export function dialog({
  children,
  afterClose,
  ...props
}: Pick<
  DialogOption,
  | 'children'
  | 'onClose'
  | 'afterClose'
  | 'responsive'
  | 'maxWidth'
  | 'dialogProps'
  | 'fullWidth'
  | 'scroll'
  | 'classes'
>) {
  let doClose: () => void
  const close = async () => {
    await afterClose?.()
    doClose?.()
  }

  UIDialog.create({
    responsive: props.responsive,
    dismissable: true,
    className: cn(
      props.classes?.paper,
      match(props.maxWidth || props.dialogProps?.maxWidth)
        .when(
          () => props.responsive,
          () => 'max-w-screen',
        )
        .with('xs', () => 'max-w-screen-mxs')
        .with('lg', () => 'max-w-screen-mlg')
        .otherwise(() => 'max-w-screen-msm'),
      props.fullWidth && 'w-[calc(100vw-2rem)]',
      props.scroll !== 'body' && 'max-h-[calc(100vh-2rem)] overflow-auto',
    ),
    onClose: props.onClose,
    children: ({ close }) => {
      doClose = close
      return <>{children}</>
    },
  })

  return { current: { close } }
}
